// Preço efetivo de um produto considerando a tabela de preço do cliente
// (se houver) — mesma lógica usada no PDV, em Pedidos/Orçamentos e na busca
// F3, pra sempre calcular igual não importa a tela.
// tabela: { tipo_ajuste, valor_ajuste, base_calculo, produtos: { [produto_id]: {percentual, preco_fixo} } } | null
// base_calculo: 'venda' (padrão, comportamento de sempre) | 'custo' — decide
// se o percentual da tabela incide sobre preco_venda ou preco_custo do
// produto. Vale tanto pro percentual geral da tabela quanto pro percentual
// específico por produto (preco_fixo continua um valor absoluto, não usa base).
const parsePT = v => parseFloat(String(v ?? 0).replace(',', '.')) || 0;

export function calcularPrecoTabela(produto, tabela, usaCusto = false) {
  if (usaCusto) return parsePT(produto.preco_custo);
  const base = tabela?.base_calculo === 'custo' ? parsePT(produto.preco_custo) : parsePT(produto.preco_venda);
  if (!tabela) return base;
  const override = tabela.produtos?.[produto.id];
  if (override?.preco_fixo != null) return parseFloat(override.preco_fixo);
  if (override?.percentual != null)
    return parseFloat((base * (1 + parseFloat(override.percentual) / 100)).toFixed(2));
  if (tabela.tipo_ajuste === 'percentual' && tabela.valor_ajuste != null)
    return parseFloat((base * (1 + parseFloat(tabela.valor_ajuste) / 100)).toFixed(2));
  return base;
}
